/**
 * admin-map-context.js
 */

import React from 'react';


export const MODE = {
  VIEW: 'view',
  FILTER: 'filter'
};


export const FILTERING_ALGO = {
  NONE: '',
  DEFAULT: 'default',
  CUSTOM: 'custom'
};


const defaultTrackSettings = {
  isFollowTrackVisible: true,
  isLeadTrackVisible: true,
  displayedPointProperty: '',
  filtering: {
    algo: FILTERING_ALGO.DEFAULT,
    accuracyFilter: 50,
    calculatedSpeedFilter: '',
    movingAvgSize: 10,
    movingAvgDev: 5,
    peuckerThreshold: 1,
    kalmanAlgo: ''
  }
};


export const AdminMapContext = React.createContext();


export const AdminMapProvider = (props) => {
  const [state, setState] = React.useState({
    mode: MODE.VIEW,
    isLoading: {
      userTracks: false,
      userTrack: false
    },
    user: null,
    userTracks: null,
    userTrack: '',
    userTrackRecord: null,

    ...defaultTrackSettings
  });


  const setMode = React.useCallback((mode) => {
    setState(p => ({
      ...p,
      mode
    }));
  }, []);


  const setIsLoading = React.useCallback((id, val) => {
    setState(p => ({
      ...p,
      isLoading: {
        ...p.isLoading,
        [id]: val
      }
    }));
  }, [])


  const setUser = React.useCallback((user) => {
    setState(p => ({
      ...p,
      user,
      userTracks: null,
      userTrack: '',
    }));
  }, [])


  const setUserTracks = React.useCallback((userTracks) => {
    setState(p => ({
      ...p,
      userTracks,
      userTrack: ''
    }));
  }, [])


  const setUserTrack = React.useCallback((userTrack) => {
    setState(p => ({
      ...p,
      userTrack: typeof userTrack === 'function' ? userTrack(p.userTrack) : userTrack,
      ...defaultTrackSettings
    }));
  }, [])


  const setUserTrackRecord = React.useCallback((userTrackRecord) => {
    setState(p => ({
      ...p,
      userTrackRecord
    }));
  }, [])


  const setIsFollowTrackVisible = React.useCallback((isFollowTrackVisible) => {
    setState(p => ({
      ...p,
      isFollowTrackVisible
    }));
  }, [])


  const setIsLeadTrackVisible = React.useCallback((isLeadTrackVisible) => {
    setState(p => ({
      ...p,
      isLeadTrackVisible
    }));
  }, [])


  const setDisplayedPointProperty = React.useCallback((displayedPointProperty) => {
    setState(p => ({
      ...p,
      displayedPointProperty,
    }));
  }, [])


  const setFilteringProperty = React.useCallback((property, value) => {
    setState(p => ({
      ...p,
      filtering: {
        ...p.filtering,
        [property]: value
      }
    }));
  }, [])
  

  const value = React.useMemo(() => ({
    ...state,
    setMode,
    setIsLoading,
    setUser,
    setUserTracks,
    setUserTrack,
    setUserTrackRecord,
    setIsFollowTrackVisible,
    setIsLeadTrackVisible,
    setDisplayedPointProperty,
    setFilteringProperty,
  }), [
    state,
    setMode,
    setIsLoading,
    setUser,
    setUserTracks,
    setUserTrack,
    setUserTrackRecord,
    setIsFollowTrackVisible,
    setIsLeadTrackVisible,
    setDisplayedPointProperty,
    setFilteringProperty,
  ]);


  return (<>
    <AdminMapContext.Provider 
      value={value}
      children={props.children}
    />
  </>);
}